import { Box, styled } from '@mui/material';

const TypographyBox = styled(Box)(({ texttransform, ellipsis }) => ({
  textTransform: texttransform || 'none',
  whiteSpace: ellipsis ? 'nowrap' : 'normal',
  overflow: ellipsis ? 'hidden' : '',
  textOverflow: ellipsis ? 'ellipsis' : '',
}));

export default TypographyBox;
